import React from 'react';
import { Col, Row } from 'antd';
import { Executive } from 'Types/PersonTypes';
import PeopleCardLarge from 'Components/common/components/PeopleCardLarge';
import { backgroundColorParsing } from 'Utils/UtilityFunctions';
import DragWrapper from './DragWrapper';

export type PeopleFollowGridProps = {
  followedPeople: Executive[],
  editEnable: boolean,
  selectedPersonSet: Set<number>,
  addRemovePerson: (flag: boolean, id: number) => void,
  isDrag: (d: boolean) => void,
  highlightFirstCard: boolean,
};

const rowStyle = { margin: '0' };
const rowGutter: [number, number] = [24, 24];
const colSpans = { xxl: { span: 4 }, xl: { span: 4 }, lg: { span: 6 } };

const PeopleFollowGrid = function PeopleFollowGrid(props: PeopleFollowGridProps) {
  const {
    followedPeople,
    editEnable,
    selectedPersonSet,
    addRemovePerson,
    isDrag,
    highlightFirstCard,
  } = props;

  return (
    <Row className="Grid-width-row person-i-follow-negative" gutter={rowGutter} style={rowStyle}>
      {editEnable
        ? followedPeople.map(
          (people: Executive) => (
            <Col key={people?.personId} {...colSpans} className="gutter-row">
              <PeopleCardLarge
                showDrawerIcon={!!people?.personNotes}
                persona={people?.archeType?.color}
                logo={people?.personImage}
                personName={people?.personName}
                tag={people?.personDesignation}
                personaType={people?.archeType?.name}
                wrapperColor={backgroundColorParsing(people?.personalityTypes)}
                personalityTypesColors={people?.personalityTypes}
                hidePersonality={false}
                follow={false}
                showCheckBox={editEnable}
                checked={selectedPersonSet.has(people.personId)}
                personId={people?.personId}
                addRemovePerson={addRemovePerson}
                company={people?.companyName}
                companyId={people?.companyId}
                location={people?.location}
              />
            </Col>
          ),
        ) : followedPeople.map(
          (people: Executive, index) => (
            <Col key={people?.personId} {...colSpans} className="gutter-row">
              <DragWrapper
                isDrag={isDrag}
                highlighted={index === 0 && highlightFirstCard}
              >
                <PeopleCardLarge
                  showDrawerIcon={!!people?.personNotes}
                  persona={people?.archeType?.color}
                  logo={people?.personImage}
                  personName={people?.personName}
                  tag={people?.personDesignation}
                  personaType={people?.archeType?.name}
                  wrapperColor={backgroundColorParsing(people?.personalityTypes)}
                  personalityTypesColors={people?.personalityTypes}
                  hidePersonality={false}
                  follow={false}
                  showCheckBox={editEnable}
                  checked={selectedPersonSet.has(people.personId)}
                  personId={people?.personId}
                  addRemovePerson={addRemovePerson}
                  company={people?.companyName}
                  companyId={people?.companyId}
                  location={people?.location}
                />
              </DragWrapper>
            </Col>
          ),
        )}
    </Row>
  );
};

export default React.memo(PeopleFollowGrid);
